import { saveObraConfig } from '@services/crud.js'
import type { ObraConfig } from '@services/db.js'

/** Campos do passo que também alimentam a config global da obra. */
const CAMPO_OBRA: Record<string, keyof ObraConfig | null> = {
  area_terreno: 'areaTotal',
  orcamento_total_obra: 'orcamentoTotal',
}

export async function syncMetadadoParaObra(campo: string, valor: string): Promise<void> {
  const obraField = CAMPO_OBRA[campo]
  if (!obraField || !valor.trim()) return

  if (obraField === 'areaTotal') {
    const n = parseFloat(valor.replace(',', '.'))
    if (!Number.isFinite(n) || n <= 0) return
    await saveObraConfig({ areaTotal: n })
    return
  }

  if (obraField === 'orcamentoTotal') {
    const n = parseFloat(valor.replace(/[^\d.,]/g, '').replace(',', '.'))
    if (!Number.isFinite(n) || n <= 0) return
    await saveObraConfig({ orcamentoTotal: n })
  }
}
